export const PAYMENT_DATA_QUERY_KEY = 'paymentData';
